<div id="wt">
  <button type="button" class="close text-primary m-2" aria-label="Close"
    (click)="activeModal.dismiss('Cross click')">
    <i class="fas fa-times-circle"></i>
  </button>
  <div class="modal-header d-flex justify-content-center border-bottom-0">
    <div>
      <h5 class="modal-title">Cambiar Estado</h5>
    </div>
  </div>
  <div class="modal-body">

    <form [formGroup]="form" (ngSubmit)="saveDataToChangeStatus()" class="form-group">
      <div class="modal-body">
        <div class="col-md-12 pb-4 pl-4 pr-4 pt-0">
          <div class="col-md-12">
            <div class="form-group row">
              <label for="staticEmail" class="col-sm-5 col-form-label" style="padding-left: inherit">Estado:
                <span class="text-danger">&#10033;</span>
              </label>
              <div class="col-sm-7">
                <select class="form-control" data-cy="select-simple" (change)="onValueStateChange($event.target.value)">
                  <option value="" >Seleccionar</option>
                  @for (value of states; track value) {
                    <option [value]="value.id">
                      {{ value.name }}
                    </option>
                  }
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>
      @if (
        statususers &&
        !statususers['selfassignment'] &&
        statususers['dontreassign'] === false &&
        statususers['assignment'] &&
        (statususers['users']!=null && statususers['users'].length > 0)) {
        <div class="col-md-12">
          <!--div class="form-group row">
          <label for="staticEmail" class="col-sm-5 col-form-label">Usuario:
            <span class="text-danger">&#10033;</span>
          </label>
          <div class="col-sm-7">
            <select (change)="onValueUserChange($event.target.value)" class="form-control" data-cy="select-simple">
              <option value="" >Seleccionar</option>
              <option *ngFor="let value of statususers['users']" [value]="value.id">
                {{ value.name }} - {{ "(" }}{{ value.email }} {{ ")" }} {{ value.profilename? '- ( Perfil: '+value.profilename+' )' :'' }}
              </option>
            </select>
          </div>
        </div-->
      </div>
    }
    @if (customfieldsRequirementType.length>0) {
      <app-customfields [fields]="customfieldsRequirementType" (customfieldsValues)="getCustomfieldsValues($event)"
        [terminarCausa]="false" [customfieldsAlls]="[]" [isSubGrupo]="false"
        [flagActionLog]="false" [resultCustomfieldsSubGrop]="[]">
      </app-customfields>
    }
    <input type="hidden" id="requirementids" value="{{requirementIds}}">
    <input type="hidden" id="actionid" value="{{actionid}}">


    <div class="modal-footer border-top-0 justify-content-center">


      <button type="submit" class="btn btn-outline-primary bg-white rounded-pill text-dark font-weight-bold" style="width: 120px" [disabled]="isSubmitting">
        @if (isSubmitting) {
          <div class="d-flex align-items-center justify-content-center">
            <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
            Cargando...
          </div>
        }
        @if (!isSubmitting) {
          <span>Guardar</span>
        }
      </button>
    </div>
  </form>
</div>
</div>
